import { useMemo } from 'react';
import { StyleSheet, useWindowDimensions } from 'react-native';
import { getWelcomeHeroLayout } from './welcome-responsive';

export function useWelcomeHeroStyles() {
  const { width, height } = useWindowDimensions();

  return useMemo(() => {
    const hero = getWelcomeHeroLayout(width, height);

    return StyleSheet.create({
      mountainSize: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        bottom: hero.mountainBottom,
      },
      chargingStation: {
        position: 'absolute',
        top: hero.chargerTop,
        alignSelf: 'center',
        width: hero.chargerWidth,
        height: hero.chargerHeight,
      },
      blackGapFill: {
        position: 'absolute',
        top: -hero.blackGapFill,
        left: 0,
        right: 0,
        height: hero.blackGapFill,
        backgroundColor: '#000000',
      },
    });
  }, [width, height]);
}
